var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconNavigationMenuVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.362 20.628a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm0-17.25a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Zm0 8.625a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconNavigationMenuVertical);
export default __webpack_public_path__ + "static/media/streamline-icon-navigation-menu-vertical.4b39540c.svg";
export { ForwardRef as ReactComponent };